<template>
  <v-dialog v-model="dialog" width="1600" scrollable>
    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        Varietà per {{ specie.nome }}
      </v-card-title>
      <v-card-subtitle class="">
        <v-row>
          <v-col cols="2">
            <v-list>
              <v-dialog width="400" v-model="dialog_serie">
                <template v-slot:activator="{ on }">
                  <v-list-item v-on="on" class="mb-2">
                    <v-list-item-avatar
                      style="cursor: pointer"
                      color="grey lighten-3"
                      class="mr-2 mt-2"
                      size="40"
                    >
                      <v-icon dark>mdi-plus</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title> Nuova Serie </v-list-item-title>
                      <v-list-item-subtitle
                        >Inserisci Nuova Serie</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-card>
                  <v-card-title class="grey--text text-subtitle-1">
                    Nuova Serie
                  </v-card-title>
                  <v-card-text>
                    <v-text-field
                      outlined
                      label="nome"
                      hide-details
                      v-model="nome_serie"
                    >
                    </v-text-field>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer />
                    <v-btn
                      outlined
                      color="green"
                      @click="salva_serie()"
                      :loading="loading_serie"
                      >Salva</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-list>
          </v-col>
          <v-col cols="5">
            <v-list>
              <NuovoColore :id_specie="specie.id" :serie="serie_attiva" />
            </v-list>
          </v-col>
          <v-col cols="5">
            <v-list>
              <NuovoVarieta :specie="specie" :colori="colori"></NuovoVarieta>
            </v-list>
          </v-col>
        </v-row>
      </v-card-subtitle>
      <v-card-text class="mt-n6">
        <v-row>
          <v-col cols="2">
            <v-divider />
            <v-list>
              <v-list-item @click="set_serie_attiva(null)">
                <v-list-item-avatar
                  color="grey lighten-3"
                  class="mr-2 mt-2"
                  size="40"
                >
                  <v-icon color="white">mdi-sprout</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title> Tutte </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <SerieElement
                :serie="serie"
                :id_specie="specie.id"
                v-for="serie in serie_sort"
                :key="serie.id"
                @set_serie_attiva="set_serie_attiva"
              />
            </v-list>
          </v-col>
          <v-divider vertical />
          <v-col cols="5">
            <v-divider />
            <v-row no-gutters>
              <v-col cols="6" v-for="colore in colori_filter" :key="colore.id">
                <ColoreElement
                  :colore="colore"
                  :id_specie="specie.id"
                  :series="serie_sort"
                  @specie_changed="fetchAllColors"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-divider vertical />
          <v-col cols="5">
            <!-- <template v-for="element in varieta_sort"> -->
              <!-- <v-divider :key="element.id_produttore + '-div1'" />
              <v-row
                :key="element.id_produttore + 'row1'"
                class="pl-2 py-2"
                no-gutters
                align="center"
                
              >
                <v-col cols="11">
                  <v-avatar>
                    <v-img :src="avatar_fornitore(element.id_produttore)" />
                  </v-avatar>
                  <span class="ml-4 text-h6 green--text font-weight-light">{{
                    fornitore(element.id_produttore).nome
                  }}</span>
                </v-col>
                <v-col cols="1">
                  <StampaVarieta
                    :id_prodotto="id_prodotto"
                    :id_fornitore="element.id_produttore"
                    v-if="daProdotto"
                  />
                </v-col>
              </v-row>
              <v-divider :key="element.id_produttore + '-div2'" />
              <template >
                <template v-for="varieta in element.varieta">
                  <VarietaElement
                    :varieta="varieta"
                    :id_specie="specie.id"
                    :series="specie.series"
                    :key="varieta.id"
                  />
                </template>
              </template> -->
              <ElementFornitore
                v-for="element in varieta_sort"
                :element="element"
                :id_prodotto="id_prodotto"
                :daProdotto="daProdotto"
                :specie="specie"
                :key="element.id_produttore"
              />
            <!-- </template> -->
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="grey" @click="close()">chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import NuovoVarieta from "./nuovo_varieta.vue";
import NuovoColore from "../colori/nuovo_colore.vue";
// import VarietaElement from "./varieta_element.vue";
import ColoreElement from "../colori/colore_element.vue";
import SerieElement from "./serie_element.vue";
// import StampaVarieta from "./stampa_varieta.vue";
import ElementFornitore from "./fornitore_element.vue";
export default {
  components: {
    NuovoVarieta,
    NuovoColore,
    // VarietaElement,
    ColoreElement,
    SerieElement,
    // StampaVarieta,
    ElementFornitore,
  },
  props: {
    specie: Object,
    id_prodotto: String,
    daProdotto: Boolean,
  },
  data() {
    return {
      dialog: false,
      nome_serie: "",
      loading_serie: false,
      dialog_serie: false,
      colori: [],
      serie_attiva: null,
      showList: [],
    };
  },
  watch: {
    "specie.colori": {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.fetchAllColors();
          this.loading = false;
        }
      },
    },
  },
  computed: {
    varieta_sort() {
      const raggruppati = this.specie.variety.reduce((acc, elemento) => {
        const { id_produttore, nome, id, id_colore, md5_colore, serie } = elemento;
        if (!acc[id_produttore]) {
          acc[id_produttore] = [];
        }
        acc[id_produttore].push({ nome, id, id_colore, md5_colore, id_produttore, serie });
        return acc;
      }, {});
      return Object.keys(raggruppati).map((id_produttore) => ({
        id_produttore,
        varieta: raggruppati[id_produttore],
      }));
    },
    serie_sort() {
      return this.specie.series
        .slice()
        .sort((a, b) => a.nome.localeCompare(b.nome));
    },
    colori_filter() {
      if (!this.serie_attiva) {
        return this.colori;
      } else {
        return this.colori.filter((colore) =>
          colore.id_series.includes(this.serie_attiva.id)
        );
      }
    },
  },
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    async fetchAllColors() {
      this.colori = await this.$store.dispatch(
        "fetch_colori_by_id",
        this.specie.colori
      );
    },
    fornitore(id_fornitore) {
      return this.$store.getters.get_fornitore_by_id(id_fornitore);
    },
    avatar_fornitore(id_fornitore) {
      return (
        process.env.VUE_APP_API_ROOT + "/fornitore/" + id_fornitore + "/avatar"
      );
    },
    salva_serie() {
      this.loading_serie = true;
      this.$store
        .dispatch("nuova_serie_specie", {
          id_specie: this.specie.id,
          nome: this.nome_serie,
        })
        .then(() => {
          this.loading_serie = false;
          this.dialog_serie = false;
          this.nome_serie = "";
        });
    },
    print() {
    },
    set_serie_attiva(id_serie) {
      this.serie_attiva = this.specie.series.find(
        (serie) => serie.id == id_serie
      );
    },
  },
};
</script>